import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { useDebug } from '../utils/hooks/useDebug.js';
import { mergeMediaQueries, debugCss, calcAlignmentProps, calcDirection, calcOffset, calcSizes, calcPadding } from '../utils/styleHelpers.js';

const Col = forwardRef(({
  align,
  as,
  children,
  className,
  direction = 'column',
  isReverse,
  justify,
  lg,
  md,
  offset,
  order,
  padding,
  paddingLeft,
  paddingRight,
  sm,
  testId,
  xl,
  xs,
  xxl,
  ...handler
}, ref) => {
  const classNames = [className, useDebug()];
  const sizes = {
    lg,
    md,
    sm,
    xl,
    xs,
    xxl
  };
  return React.createElement(ColElement, _extends({
    ref: ref,
    $align: align,
    $direction: direction,
    $isReverse: isReverse,
    $justify: justify,
    $offset: offset,
    $order: order,
    $padding: padding,
    $paddingLeft: paddingLeft,
    $paddingRight: paddingRight,
    $sizes: sizes,
    as: as,
    className: classNames.join(' '),
    "data-cy": testId
  }, handler), children);
});
Col.displayName = 'Col';
var Col$1 = Col;
const ColElement = styled.div.withConfig({
  displayName: "Col__ColElement",
  componentId: "sc-agrgdi-0"
})(["box-sizing:border-box;display:flex;flex:1 0 auto;flex-direction:column;max-width:100%;", " ", ""], mergeMediaQueries(calcPadding, calcSizes, calcOffset, calcAlignmentProps('$order'), calcDirection('column'), calcAlignmentProps('$align'), calcAlignmentProps('$justify')), debugCss('col'));

export { Col$1 as default };
//# sourceMappingURL=Col.js.map
